import { FeedbackRequest } from '@/services/feedbackApi/feedbackApi';
import { selectMessageById } from '@/store/chat/chat.slice';
import { Feedback } from '@/store/feedback/feedbackSlice';
import { reduxStore } from '@/store/store';

import locale_en from '../../locales/en-GB.json';

export const mapFeedbackToRequest = (feedback: Feedback): FeedbackRequest => {
  const state = reduxStore.getState();
  const regex = /\bragDocuments\.[^\s]+/g;

  const lastQuestionContent = feedback.lastQuestionId
    ? selectMessageById(feedback.lastQuestionId)(state)?.content
    : null;

  const lastAnswerContent = feedback.lastAnswerId
    ? selectMessageById(feedback.lastAnswerId)(state)?.content.replace(
        regex,
        (match) => (locale_en as Record<string, string>)[`chatPage.${match}`],
      )
    : null;

  let rating: 'negative' | 'neutral' | 'positive' | undefined;

  if (feedback.rate !== undefined) {
    if (feedback.rate === 1 || feedback.rate === 2) {
      rating = 'negative';
    } else if (feedback.rate === 3) {
      rating = 'neutral';
    } else if (feedback.rate === 4 || feedback.rate === 5) {
      rating = 'positive';
    }
  }

  const request: FeedbackRequest = {
    detailed_answer: feedback.detail,
    user_id: feedback.userId,
  };

  if (lastQuestionContent) {
    request.last_question = lastQuestionContent;
  }

  if (lastAnswerContent) {
    let cleanedAnswer = lastAnswerContent;
    const regex = /```json[\s\S]*?```/g;

    if (regex.test(cleanedAnswer)) {
      cleanedAnswer = cleanedAnswer.replace(regex, '').trim();
    }

    request.last_answer = cleanedAnswer;
  }

  if (rating) {
    request.rating = rating;
  }

  const followUpsText = feedback?.follow_ups?.filter((item) => item?.trim()).join('\n');

  if (followUpsText) {
    request.last_answer += `\n\n➜ Follow Ups:\n${followUpsText}`;
  }

  return request;
};
